// src/shared/legal.js — малки помощници за правната форма на фирмата.

// Подсказва правната форма от името (наставка) или броя собственици.
// Връща 'ЕООД' | 'ООД' | '' (не е сигурно). Само предложение — потребителят
// може да го смени в „Мои фирми". 'ЕООД' се проверява ПРЕДИ 'ООД', защото
// съдържа „ООД" като част.
export function suggestLegalForm(company) {
  const name = String((company && company.name) || '').toUpperCase();
  if (/ЕООД/.test(name)) return 'ЕООД';
  if (/ООД/.test(name)) return 'ООД';
  const owners = Array.isArray(company && company.shareholders) ? company.shareholders.length : 0;
  if (owners === 1) return 'ЕООД';
  if (owners >= 2) return 'ООД';
  return '';
}

// Реалната форма за макета: изричното поле, иначе подсказка.
export function legalFormOf(company) {
  return String((company && company.legal_form) || '') || suggestLegalForm(company);
}
